// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.small-margin[data-v-84ee0a6a] .section-basic__title{margin-bottom:1.6rem}@media (max-width:767px){.small-margin[data-v-84ee0a6a] .section-basic__title{margin-bottom:.8rem}}.block-list[data-v-84ee0a6a] .block-text-container .block-text p{line-height:2rem}.block-list[data-v-84ee0a6a]:not(:last-child){margin-bottom:4.8rem}@media (max-width:767px){.block-list[data-v-84ee0a6a]:not(:last-child){margin-bottom:3.2rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
